export * from './char-counter.directive';
export * from './char-counter.module';



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/inputs/index.ts